import { type LanguageCode as LibraryLanguage } from 'charting_library';

export interface II18nService {
  getLanguage(): LibraryLanguage;
}

export enum SystemLanguage {
  /** العربية */
  Ar = 'ar',
  /**  বাংলা */
  Bn = 'bn',
  /** 简体中文 */
  Cn = 'cn',
  /** English */
  En = 'en',
  /** Español */
  Es = 'es',
  /** فارسی */
  Fa = 'fa',
  /** Français */
  Fr = 'fr',
  /** हिन्दी */
  Hi = 'hi',
  /** Bahasa Indonesia */
  Id = 'id',
  /** 日本語 */
  Jp = 'jp',
  /** 한국어 */
  Ko = 'ko',
  /** Bahasa Malaysia */
  Ms = 'ms',
  /** اردو */
  Pk = 'pk',
  /** Português */
  Pt = 'pt',
  /** ไทย */
  Th = 'th',
  /** Türkçe */
  Tr = 'tr',
  /** Tiếng Việt */
  Vi = 'vi',
  /** 繁體中文 */
  Zh = 'zh',
}
